import { useState, useEffect } from "react";
import LoaderWithBackdrop from "../../loader/LoaderWithBackdrop";

function TwoImagesPreview({
  imagesList,
  maxHeight,
  checkImagesWiderThanTall,
  imageTag,
}) {
  const [bothWiderImages, setBothWiderImages] = useState(null);

  useEffect(() => {
    const checkImages = async () => {
      const result = await checkImagesWiderThanTall(2);
      setBothWiderImages(result);
    };

    checkImages();
  }, [imagesList]);

  if (bothWiderImages == null) {
    return (
      <>
        <div style={{ position: "relative", height: `calc(${maxHeight} / 2)` }}>
          <LoaderWithBackdrop isAbsolute={true} />
        </div>
      </>
    );
  }

  return (
    <div
      className="row m-0 two-images-preview"
      style={{ maxHeight: maxHeight }}
    >
      {imagesList.map((image, index) => {
        const isFirst = index === 0;
        const isLast = index === imagesList.length - 1;
        return (
          <div
            className={`col-${bothWiderImages ? "12" : "6"} feed-image-wrapper`}
            style={{
              height: `${
                bothWiderImages ? `calc((${maxHeight} / 2) - 4px)` : maxHeight
              }`
            }}
          >
            <div
              style={{
                height: `${
                  bothWiderImages ? `calc((${maxHeight} / 2) - 8px)` : maxHeight
                }`,

                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                borderBottomLeftRadius: "inherit",
                borderBottomRightRadius: "inherit",
              }}
            >
              {imageTag(image, index)}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TwoImagesPreview;
